import {
  Injectable
} from '@angular/core';

import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';


import {
  AuthService
} from '../auth';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const self = this;

    if (!this.auth.isAuthenticated()) {
      this.auth.logout();
      this.router.navigate(['auth', 'login']);
      return false;
    }
    /*
    console.log("Has role distribtor: " + this.auth.hasRole("distributor"));
    console.log("Has role admin: " + this.auth.hasRole("administrator"));
    console.log("Has role manager: " + this.auth.hasRole("manager"));
    console.log("Has role associate: " + this.auth.hasRole("associate"));
    */

    return !this.auth.hasRole("distributor") &&
      (this.auth.hasRole('administrator') ||
        this.auth.hasRole('manager') ||
        this.auth.hasRole('associate'));
  }
}
